<template>
  <div id="traveller-sidebar" class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo" ref="logoDiv">
      <a class="simple-text logo-mini" aria-label="sidebar mini logo" href="#"></a>
      <a class="simple-text logo-normal" href="#"><span class="admin">admin</span><span class="traveller">Traveller</span></a>
    </div>
    <PhoneUI ref="phoneDiv"/>
    <Notifications ref="notificationsDiv"/> 
    <div class="sidebar-wrapper" ref="sidebarScrollArea" :style="sidebarWrapperStyle">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in userNavigation"
                        :key="link.name + index"
                        :link="link" v-on:itemClick="onSelectItem">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink" v-on:itemClick="onSelectItem">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
    <div class="organization-logo" ref="orgLogo">
      <b-img center fluid-grow :src="orgLogo" @load="adjustSidebarHeight"/>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'

  import {createUserNavigation} from '../../TravellerNavigation'

import PhoneUI from '@/components/Dispatching/VoIP/PhoneUI';
import Notifications from '@/components/Dispatching/Notifications'
import organizationDetails from '@/store/organization/organizationDetails';

  export default {
    components: { PhoneUI, Notifications },
    props: {
      title: {
        type: String,
        default: 'Trapeze Traveller',
        description: 'Trapeze Traveller title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'primary',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return {
        activeView: "",
        logoHeight: 0,
        otherUIElementsheight: 0
      }
    },

    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea, {
          suppressScrollX: true
        })
      },
      adjustSidebarHeight() {
        this.$nextTick(() => {
          this.otherUIElementsheight = 0;
          if (this.$refs.notificationsDiv.$el?.offsetHeight) {
            this.otherUIElementsheight += this.$refs.notificationsDiv.$el.offsetHeight;
          }
          if (this.$refs.phoneDiv.$el?.offsetHeight) {
            this.otherUIElementsheight += this.$refs.phoneDiv.$el.offsetHeight;
          }
          if (this.$refs.logoDiv?.offsetHeight) {
            this.otherUIElementsheight += this.$refs.logoDiv.offsetHeight;
          }
          if (this.$refs.orgLogo?.offsetHeight) {
            this.logoHeight = this.$refs.orgLogo.offsetHeight;
          }
        });
      },
      fetchOrganizationLogo() {
        this.$store.dispatch('organizationDetails/getLogo')
        .catch(() => {
          //Organization does not have logo or there were some other problem.
        });
      },
      onSelectItem(){
        // OnSelectItem is used in SideBar.vue.
        // Empty function needed to prevent errors
      }
    },
    computed: {
      userNavigation(){
        return createUserNavigation();
      },
      orgLogo() {
        return this.$store.state.organizationDetails.logoImage;
      },
      sidebarWrapperStyle() {
        return {
          height: `calc(100vh - ${this.otherUIElementsheight}px - ${this.logoHeight}px) !important`
        };
      }
    },
    beforeCreate() {
        if (!this.$store.state.organizationDetails) {
          this.$store.registerModule('organizationDetails', organizationDetails);
        }
    },
    mounted () {
      this.initScrollBarAsync();
      this.fetchOrganizationLogo();
      this.adjustSidebarHeight();
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    },
    

  }
</script>

<style scoped>
.organization-logo {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1001;
  pointer-events: none;
}
</style>
